export default __webpack_public_path__ + "static/media/schwarzP.6e448256.jpg";